
































import { Component, Mixins } from 'vue-property-decorator'
import KintaiCardCommon from '../mixins/KintaiCardCommon.vue'

@Component
export default class KintaiCardHoliday extends Mixins(KintaiCardCommon) {}
